module.exports = __webpack_public_path__ + "static/media/home_mobile.b530d5c3.jpg";